import { useContext } from 'react';
import { titleCase } from 'title-case';

import UserContext from 'context/userContext';
import useFeatureFlag from 'hooks/useFeatureFlag';
import { COMMUNITIES } from 'constants/featureFlags';

/** Same gate as the navbar: the `communities` flag and at least one community in the company. */
export function useCanAccessCommunities(): boolean {
  const user = useContext(UserContext);
  const isCommunitiesEnabled = useFeatureFlag(COMMUNITIES);

  return !!isCommunitiesEnabled && !!user?.company?.hasCommunities;
}

export function useCommunitiesLabel(): string {
  const user = useContext(UserContext);

  return titleCase(user?.company?.customCommunitiesName || 'Communities');
}
